<div class="custom-theme-modal" [class.open]="isOpen">
  <div class="modal-overlay" (click)="closeModal()"></div>
  
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title">🎨 Personalizar Tema</h3>
      <button class="close-btn" (click)="closeModal()" aria-label="Cerrar modal">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <!-- Colores Principales -->
      <div class="color-section">
        <h4 class="section-title">Colores Principales</h4>
        
        <div class="color-group">
          <div class="color-input-group">
            <label class="color-label">
              <span class="label-text">Color Primario</span>
              <div class="color-preview" [style.background-color]="getColorPreview(customColors.primary)">
                <input 
                  type="color" 
                  [value]="customColors.primary"
                  (change)="onColorChange('primary', $event)"
                  class="color-input"
                  title="Seleccionar color primario"
                />
              </div>
            </label>
            
            <!-- Colores predefinidos para primario -->
            <div class="predefined-colors">
              <span class="predefined-label">Colores rápidos:</span>
              <div class="color-palette">
                <button 
                  *ngFor="let color of predefinedColors" 
                  class="color-swatch"
                  [style.background-color]="color.value"
                  [title]="color.name"
                  (click)="selectPredefinedColor(color.value, 'primary')"
                ></button>
              </div>
            </div>
          </div>

          <div class="color-input-group">
            <label class="color-label">
              <span class="label-text">Color Secundario</span>
              <div class="color-preview" [style.background-color]="getColorPreview(customColors.secondary)">
                <input 
                  type="color" 
                  [value]="customColors.secondary"
                  (change)="onColorChange('secondary', $event)"
                  class="color-input"
                  title="Seleccionar color secundario"
                />
              </div>
            </label>
          </div>

          <div class="color-input-group">
            <label class="color-label">
              <span class="label-text">Color de Acento</span>
              <div class="color-preview" [style.background-color]="getColorPreview(customColors.accent)">
                <input 
                  type="color" 
                  [value]="customColors.accent"
                  (change)="onColorChange('accent', $event)"
                  class="color-input"
                  title="Seleccionar color de acento"
                />
              </div>
            </label>
          </div>
        </div>

        <button class="generate-btn" (click)="generateFromPrimary()">
          ✨ Generar colores automáticamente
        </button>
      </div>

      <!-- Colores de Fondo -->
      <div class="color-section">
        <h4 class="section-title">Colores de Fondo</h4>
        
        <div class="color-group">
          <div class="color-input-group">
            <label class="color-label">
              <span class="label-text">Fondo Principal</span>
              <div class="color-preview" [style.background-color]="getColorPreview(customColors.background)">
                <input 
                  type="color" 
                  [value]="customColors.background"
                  (change)="onColorChange('background', $event)"
                  class="color-input"
                  title="Seleccionar color de fondo"
                />
              </div>
            </label>
          </div>

          <div class="color-input-group">
            <label class="color-label">
              <span class="label-text">Fondo de Superficie</span>
              <div class="color-preview" [style.background-color]="getColorPreview(customColors.surface)">
                <input 
                  type="color" 
                  [value]="customColors.surface"
                  (change)="onColorChange('surface', $event)"
                  class="color-input"
                  title="Seleccionar color de superficie"
                />
              </div>
            </label>
          </div>
        </div>
      </div>

      <!-- Colores de Texto -->
      <div class="color-section">
        <h4 class="section-title">Colores de Texto</h4>
        
        <div class="color-group">
          <div class="color-input-group">
            <label class="color-label">
              <span class="label-text">Texto Principal</span>
              <div class="color-preview" [style.background-color]="getColorPreview(customColors.text)">
                <input 
                  type="color" 
                  [value]="customColors.text"
                  (change)="onColorChange('text', $event)"
                  class="color-input"
                  title="Seleccionar color de texto"
                />
              </div>
            </label>
          </div>

          <div class="color-input-group">
            <label class="color-label">
              <span class="label-text">Texto Secundario</span>
              <div class="color-preview" [style.background-color]="getColorPreview(customColors.textSecondary)">
                <input 
                  type="color" 
                  [value]="customColors.textSecondary"
                  (change)="onColorChange('textSecondary', $event)"
                  class="color-input"
                  title="Seleccionar color de texto secundario"
                />
              </div>
            </label>
          </div>

          <div class="color-input-group">
            <label class="color-label">
              <span class="label-text">Color de Borde</span>
              <div class="color-preview" [style.background-color]="getColorPreview(customColors.border)">
                <input 
                  type="color" 
                  [value]="customColors.border"
                  (change)="onColorChange('border', $event)"
                  class="color-input"
                  title="Seleccionar color de borde"
                />
              </div>
            </label>
          </div>
        </div>
      </div>

      <!-- Preview del Tema -->
      <div class="theme-preview-section">
        <h4 class="section-title">Vista Previa</h4>
        <div class="theme-preview">
          <div class="preview-header" [style.background-color]="customColors.primary">
            <span [style.color]="getContrastColor(customColors.primary)">Header</span>
          </div>
          <div class="preview-content" [style.background-color]="customColors.background">
            <div class="preview-card" [style.background-color]="customColors.surface" [style.border-color]="customColors.border">
              <h5 [style.color]="customColors.text">Título del Producto</h5>
              <p [style.color]="customColors.textSecondary">Descripción del producto</p>
              <button class="preview-btn" [style.background-color]="customColors.accent" [style.color]="getContrastColor(customColors.accent)">
                Botón
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-secondary" (click)="resetToDefaults()">
        🔄 Restablecer
      </button>
      <button class="btn-primary" (click)="applyCustomTheme()">
        ✅ Aplicar Tema
      </button>
    </div>
  </div>
</div>
